import React, { useState, useEffect } from "react";
import {
  Box,
  Container,
  Typography,
  Paper,
  useTheme,
  useMediaQuery,
  Grid,
  Tabs,
  Tab,
  Stack,
  TextField,
  Divider,
  CircularProgress,
} from "@mui/material";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import AttachMoneyRoundedIcon from "@mui/icons-material/AttachMoneyRounded";
import AccessTimeRoundedIcon from "@mui/icons-material/AccessTimeRounded";
import CalendarMonthRoundedIcon from "@mui/icons-material/CalendarMonthRounded";
import StoreRoundedIcon from "@mui/icons-material/StoreRounded";
import ArrowDropDownRoundedIcon from "@mui/icons-material/ArrowDropDownRounded";
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";
import NotificationsRoundedIcon from "@mui/icons-material/NotificationsRounded";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useSelector } from "react-redux";
import { axiosInstance as axios, endpoint } from "../../api/axios";
import { useSnackbar } from "notistack";

import { Link } from "react-router-dom";
import BottomNavigationBar from "../../components/navbar/BottomNavigationBar";
import NotificationDialog from "../../components/home/dialog/NotificationDialog";
import DrGadgetLogo from '../../assets/img/dr-gadget.png';
// import UnitDialog from "../../components/home/dialog/UnitDialog";

const Dashboard = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const currentUser = useSelector((state) => {
    const id = state.user.currentUserId;
    return state.user.users[id];
  });

  const { enqueueSnackbar } = useSnackbar();

  const [loading, setLoading] = useState(false);

  const [openNotif, setOpenNotif] = useState(false);

  const handleOpenNotif = () => {
    setOpenNotif(true);
  };
  const handleCloseNotif = () => {
    setOpenNotif(false);
  };

  // const [openUnit, setOpenUnit] = useState(false);

  // const handleOpenUnit = () => {
  //   setOpenUnit(true);
  // };
  // const handleCloseUnit = () => {
  //   setOpenUnit(false);
  // };

  const [selectedTab, setSelectedTab] = useState(0);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const [dataFetched, setDataFetched] = useState(false);

  const [dataFilter, setDataFilter] = useState({received: "",process: "",
    completed: "",paid: "",claim: "",total_order: "",total_income: "",total_device: "",
  });

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  useEffect(() => {
    const fetchData = async () => {
      if (!startDate || !endDate || dataFetched) return;
  
      setLoading(true);
  
      try {
        const payload = {
          start_date: startDate,
          end_date: endDate,
        };
  
        const response = await axios.post(endpoint.Dashboard.static, payload, {
          headers: {
            Authorization: `${currentUser.token_type} ${currentUser.token}`,
          },
        });
  
        setDataFilter({
          received: response.data.data?.received,
          process: response.data.data?.process,
          completed: response.data.data?.completed,
          paid: response.data.data?.paid,
          claim: response.data.data?.claim,
          total_order: response.data.data?.total_order,
          total_income: response.data.data?.total_income,
          total_device: response.data.data?.total_device,
        });
  
        enqueueSnackbar("Berhasil difilter!", { variant: "success" });
  
        // Tandai bahwa data sudah diambil untuk kombinasi ini
        setDataFetched(true);
  
      } catch (error) {
        enqueueSnackbar("Gagal difilter!", { variant: "error" });
      } finally {
        setLoading(false);
      }
    };
    // console.log("Ini data filter", dataFilter)
  
    fetchData();
  }, [startDate, endDate, selectedTab, dataFetched]);
  
  // Reset flag saat user mengubah tanggal atau tab
  useEffect(() => {
    setDataFetched(false);
  }, [startDate, endDate, selectedTab]);

  return (
    <>
      <Box
        sx={{
          position: "absolute",
          top: 30,
          width: "100%",
          textAlign: "center",
          zIndex: 10,
        }}
      >
        {/* Notifikasi Bulat */}
        <Box
          sx={{
            position: "absolute",
            top: -10,
            right: 20,
            width: 30,
            height: 30,
            backgroundColor: "success.light",
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 20,
            boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
            cursor: "pointer",
          }}
          onClick={handleOpenNotif}
        >
          <NotificationsRoundedIcon sx={{ color: "white", fontSize: 20 }} />
        </Box>

        {/* Judul */}
          <Box
          sx={{
            position: "absolute",
            top: 30,
            width: "100%",
            textAlign: "center",
            zIndex: 10,
          }}
        >
        <img
          src={DrGadgetLogo} 
          alt="Dr Gadget Indonesia"
          style={{
            width: isMobile ? "80%" : "60%", 
            maxWidth: "15%",
            height: "auto",
            objectFit: "contain",
            boxShadow: "0 0 6px rgba(211, 205, 205, 0.5)",
          }}
        />
        </Box>
        {/* <Typography
          variant={isMobile ? "body1" : "h6"}
          sx={{
            fontWeight: "bold",
            fontFamily: '"Arial", Times, serif',
            color: "white",
            textShadow: "0 0 6px rgba(0,0,0,0.5)",
          }}
        >
          Dr Gadget Indonesia
        </Typography> */}

        {/* <Typography
          variant={isMobile ? "body1" : "h6"}
          sx={{
            fontWeight: "bold",
            fontFamily: '"Arial", Times, serif',
            color: "white",
            textShadow: "0 0 6px rgba(0,0,0,0.5)",
          }}
        >
          {currentUser ? currentUser?.name : ""}
        </Typography> */}

        {/* Tombol Pindah Role */}
        {/* <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            gap: 1,
            px: 2,
            py: 1,
            backgroundColor: "success.light",
            borderRadius: 20,
            mt: 1,
            cursor: "pointer",
          }}
        >
          <Link to="/role" style={{ textDecoration: "none" }}>
            <Typography
              variant={isMobile ? "h6" : "body2"}
              sx={{
                color: "white",
                textShadow: "0 0 6px rgba(0,0,0,0.5)",
              }}
            >
              Pindah Ke Teknisi
            </Typography>
          </Link>
          <ArrowDropDownRoundedIcon sx={{ fontSize: 18, color: "white" }} />
        </Box> */}
      </Box>

      <Box
        sx={{
          minHeight: "100vh",
          backgroundImage: "url('/background.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          p: isMobile ? 2 : 4,
        }}
      >
        <Box sx={{ height: "24px" }} />
        <Container maxWidth="md">
          <Box sx={{ mb: 4, textAlign: "center", height: 150 }}>
            <Paper
              elevation={4}
              sx={{
                p: 4,
                borderRadius: 3,
                backgroundColor: "rgba(255, 255, 255, 0.9)",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 2,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <Box
                  sx={{
                    width: 15,
                    height: 15,
                    bgcolor: "success.main",
                    borderRadius: "50%",
                  }}
                />
                <Typography
                  variant="h5"
                  fontWeight="bold"
                  color="text.secondary"
                >
                  Dr Gadget Indonesia
                </Typography>
              </Box>

              {/* <Box
                sx={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 1,
                  px: 2,
                  py: 1,
                  backgroundColor: "success.light",
                  borderRadius: 20,
                  cursor: "pointer",
                }}
                onClick={handleOpenUnit}
              >
                <StoreRoundedIcon sx={{ fontSize: 18, color: "light.dark" }} />
                <Typography
                  variant="body2"
                  fontWeight="bold"
                  color="light.dark"
                >
                  Citywalk Sudirman
                </Typography>
              </Box> */}
            </Paper>
          </Box>

          <Grid
            container
            spacing={3}
            justifyContent="center"
            alignItems="center"
            sx={{ textAlign: "center" }}
          >
            <Grid item xs={12} sm={6} md={3}>
              <Link to="#" style={{ textDecoration: "none" }}>
                <Paper
                  elevation={3}
                  sx={{
                    p: 3,
                    borderRadius: 3,
                    backgroundColor: "rgba(255, 255, 255, 0.9)",
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 2,
                    cursor: "pointer",
                    "&:hover": {
                      backgroundColor: "rgba(255, 255, 255, 0.95)",
                    },
                  }}
                >
                  <Box>
                    <Typography
                      variant="h6"
                      fontWeight="bold"
                      color="text.primary"
                    >
                      {dataFilter?.received ? dataFilter?.received : "-"}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Diterima
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      width: 40,
                      height: 40,
                      backgroundColor: "success.light",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <CalendarMonthRoundedIcon
                      sx={{ fontSize: 20, color: "light.main" }}
                    />
                  </Box>
                </Paper>
              </Link>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <Link to="#" style={{ textDecoration: "none" }}>
                <Paper
                  elevation={3}
                  sx={{
                    p: 3,
                    borderRadius: 3,
                    backgroundColor: "rgba(255, 255, 255, 0.9)",
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 2,
                    cursor: "pointer",
                    "&:hover": {
                      backgroundColor: "rgba(255, 255, 255, 0.95)",
                    },
                  }}
                >
                  <Box>
                    <Typography
                      variant="h6"
                      fontWeight="bold"
                      color="text.primary"
                    >
                      {dataFilter?.completed ? dataFilter?.completed : "-"}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Selesai
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      width: 40,
                      height: 40,
                      backgroundColor: "success.light",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <CheckCircleRoundedIcon
                      sx={{ fontSize: 20, color: "light.main" }}
                    />
                  </Box>
                </Paper>
              </Link>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <Link to="#" style={{ textDecoration: "none" }}>
                <Paper
                  elevation={3}
                  sx={{
                    p: 3,
                    borderRadius: 3,
                    backgroundColor: "rgba(255, 255, 255, 0.9)",
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 2,
                    cursor: "pointer",
                    "&:hover": {
                      backgroundColor: "rgba(255, 255, 255, 0.95)",
                    },
                  }}
                >
                  <Box>
                    <Typography
                      variant="h6"
                      fontWeight="bold"
                      color="text.primary"
                    >
                      {dataFilter?.process ? dataFilter?.process : "-"}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Diproses
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      width: 40,
                      height: 40,
                      backgroundColor: "success.light",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <AccessTimeRoundedIcon
                      sx={{ fontSize: 20, color: "light.main" }}
                    />
                  </Box>
                </Paper>
              </Link>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <Link to="#" style={{ textDecoration: "none" }}>
                <Paper
                  elevation={3}
                  sx={{
                    p: 3,
                    borderRadius: 3,
                    backgroundColor: "rgba(255, 255, 255, 0.9)",
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 2,
                    cursor: "pointer",
                    "&:hover": {
                      backgroundColor: "rgba(255, 255, 255, 0.95)",
                    },
                  }}
                >
                  <Box>
                    <Typography
                      variant="h6"
                      fontWeight="bold"
                      color="text.primary"
                    >
                      {dataFilter?.paid ? dataFilter?.paid : "-"}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Dibayar
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      width: 40,
                      height: 40,
                      backgroundColor: "success.light",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <AttachMoneyRoundedIcon
                      sx={{ fontSize: 20, color: "light.main" }}
                    />
                  </Box>
                  {loading && (
                    <CircularProgress
                      size={50}
                      sx={{
                        position: "absolute",
                        right: "50%",
                        top: "50%",
                        transform: "translate(50%, -50%)",
                      }}
                    />
                  )}
                </Paper>
              </Link>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Box sx={{ mt: -2 }}>
        <Paper
          elevation={3}
          sx={{ p: 2, backgroundColor: "rgba(255, 255, 255, 0.9)" }}
        >
          <Tabs
            value={selectedTab}
            onChange={handleTabChange}
            variant="scrollable"
            scrollButtons="auto"
            sx={{ mb: 2 }}
          >
            <Tab icon={<CalendarMonthRoundedIcon />} />
            <Tab label="Harian" />
            <Tab label="Mingguan" />
            <Tab label="Bulanan" />
            <Tab label="Tahunan" />
          </Tabs>

          <LocalizationProvider dateAdapter={AdapterDateFns}>
            {selectedTab === 0 && (
              <Box
                sx={{
                  display: "flex",
                  gap: 2,
                  flexDirection: isMobile ? "column" : "row",
                }}
              >
                <DatePicker
                  label="Dari Tanggal"
                  value={startDate ? new Date(startDate) : null}
                  onChange={(newValue) => {
                    const formatted = new Date(newValue).toISOString().split('T')[0];
                    setStartDate(formatted);
                  }}
                  slotProps={{ textField: { fullWidth: true } }}
                />
                <DatePicker
                  label="Sampai Tanggal"
                  value={endDate ? new Date(endDate) : null}
                  onChange={(newValue) => {
                    const formatted = new Date(newValue).toISOString().split('T')[0];
                    setEndDate(formatted);
                  }}
                  slotProps={{ textField: { fullWidth: true } }}
                />
              </Box>
            )}

            {selectedTab === 1 && (
              <Box mt={2}>
                <DatePicker
                  label="Pilih Tanggal (Harian)"
                  value={startDate ? new Date(startDate) : null}
                  onChange={(newValue) => {
                    const formatted = new Date(newValue).toISOString().split('T')[0];
                    setStartDate(formatted);
                  }}
                  slotProps={{ textField: { fullWidth: true } }}
                />
              </Box>
            )}

            {selectedTab === 2 && (
              <Box mt={2}>
                <DatePicker
                  label="Pilih Tanggal (Mingguan)"
                  views={["day"]}
                  value={startDate ? new Date(startDate) : null}
                  onChange={(newValue) => {
                    const formatted = new Date(newValue).toISOString().split('T')[0];
                    setStartDate(formatted);
                  }}
                  slotProps={{ textField: { fullWidth: true } }}
                  // Anda bisa hitung minggu dari tanggal ini
                />
              </Box>
            )}

            {selectedTab === 3 && (
              <Box mt={2}>
                <DatePicker
                  label="Pilih Bulan"
                  views={["year", "month"]}
                  value={startDate ? new Date(startDate) : null}
                  onChange={(newValue) => {
                    const formatted = new Date(newValue).toISOString().split('T')[0];
                    setStartDate(formatted);
                  }}
                  slotProps={{ textField: { fullWidth: true } }}
                />
              </Box>
            )}

            {selectedTab === 4 && (
              <Box mt={2}>
                <DatePicker
                  label="Pilih Tahun"
                  views={["year"]}
                  value={startDate ? new Date(startDate) : null}
                  onChange={(newValue) => {
                    const formatted = new Date(newValue).toISOString().split('T')[0];
                    setStartDate(formatted);
                  }}
                  slotProps={{ textField: { fullWidth: true } }}
                />
              </Box>
            )}
          </LocalizationProvider>

          <Grid container spacing={3} sx={{ mt: 2 }}>
            <Grid item xs={12} sm={6} md={6}>
            {loading && (
                  <CircularProgress
                    size={50}
                    sx={{
                      position: "absolute",
                      right: "50%",
                      top: "50%",
                      transform: "translate(50%, -50%)",
                    }}
                  />
                )}
              <Paper
                elevation={3}
                sx={{
                  p: 3,
                  borderRadius: 3,
                  backgroundImage: "url('/background.jpg')",
                  height: "100%",
                }}
              >
                <Box
                  display="flex"
                  flexDirection="row"
                  gap={3}
                  alignItems="center"
                >
                  {/* Kiri: Total Pendapatan */}
                  <Box
                    sx={{
                      flex: 1,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      textAlign: "center",
                    }}
                  >
                    <Box
                      sx={{
                        width: 50,
                        height: 50,
                        bgcolor: "success.light",
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        mb: 2,
                      }}
                    >
                      <AttachMoneyRoundedIcon
                        sx={{ color: "white", fontSize: 24 }}
                      />
                    </Box>
                    <Typography variant="body2" color="white" sx={{ mb: 0.5 }}>
                      Total Pendapatan
                    </Typography>
                    <Typography variant="h6" fontWeight="bold" color="white">
                      Rp {dataFilter?.total_income ? dataFilter?.total_income : "-"}
                    </Typography>
                  </Box>

                  <Divider
                    orientation="vertical"
                    flexItem
                    sx={{ borderColor: "white", mx: 2 }}
                  />

                  {/* Kanan: Status Device dan Order */}
                  <Stack spacing={2} flex={1}>
                    {/* Device */}
                    <Box display="flex" alignItems="center" gap={2}>
                      <Box
                        sx={{
                          width: 40,
                          height: 40,
                          bgcolor: "success.light",
                          borderRadius: "50%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <CheckCircleRoundedIcon sx={{ color: "white" }} />
                      </Box>
                      <Box>
                        <Typography
                          variant="body2"
                          color="white"
                          fontWeight="bold"
                        >
                          Device
                        </Typography>
                        <Typography variant="caption" color="white">
                        {dataFilter?.total_device ? dataFilter?.total_device : "-"}
                        </Typography>
                      </Box>
                    </Box>

                    <Divider sx={{ borderColor: "white", mx: 1 }} />

                    {/* Order */}
                    <Box display="flex" alignItems="center" gap={2}>
                      <Box
                        sx={{
                          width: 40,
                          height: 40,
                          bgcolor: "primary.light",
                          borderRadius: "50%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <ArrowBackIosNewRoundedIcon
                          sx={{ color: "white", fontSize: 18 }}
                        />
                      </Box>
                      <Box>
                        <Typography
                          variant="body2"
                          color="white"
                          fontWeight="bold"
                        >
                          Order
                        </Typography>
                        <Typography variant="caption" color="white">
                        {dataFilter?.total_order ? dataFilter?.total_order : "-"}
                        </Typography>
                      </Box>
                    </Box>
                  </Stack>
                </Box>
               
              </Paper>
            </Grid>
          </Grid>
        </Paper>
      </Box>

      <NotificationDialog open={openNotif} handleClose={handleCloseNotif} />

      {/* <UnitDialog openUnit={openUnit} handleCloseUnit={handleCloseUnit} /> */}

      <BottomNavigationBar />
    </>
  );
};

export default Dashboard;
